export const colorCorrectionData = [
  {
    id: 1,
    img: "https://www.photographersedit.com/wp-content/uploads/2024/12/sax-player.jpg",
    title: " Hand crafted color correction",
    price: "Only $0.08 per photo.",
    para1:
      "   Achieving the perfect color balance can be a challenge, but with captureedits.com , you don’t have to worry. We offer precise and customized wedding photo color correction services tailored to bring out the best in your images.",
    para2:
      " Whether you’re working with RAW or JPEG files, feel free to upload your Lightroom catalogs alongside your images/Smart Previews to Our services go beyond basic color correction. We take the time to understand your unique style, enhancing each image by hand to ensure it aligns perfectly with your vision.  ",
    para3:
      "Your style is our compass, and we’re committed to refining every detail until the final images are an exact match.  maintain any edits you’ve already made. At captureedits.com Every color correction is customized to your specific order settings and Job Notes. You’ve done the incredible work of capturing emotions and turning moments into lasting memories—now let us perfect those memories with our expert touch.",
  },

  {
    id: 2,
    img: "https://www.photographersedit.com/wp-content/uploads/2024/12/sax-player.jpg",
    title: "",
    price: "Only $0.08 per photo.",
    para1:
      "We hand adjust all of the critical components of professional photo color correction. We pay detailed attention hand color correct every image, one at a time.",
    // list1: " White balance & exposure correction",
    // list2: "  Contrast and tone adjustments",
    // list3: "Skin tone refinement ",
    // list4: "Natural color enhancement ",
    // list5: "Matching across full sets ",
    list1: "White Balance",
    list2: "Contrast",
    list3: "Temperature",
    list4: "Vibrance",
    list5: "Tint",
    list6: "Saturation",
    list7: "Exposure",
    list8: "Clarity",
    list9: "Highlights",
    list10: "Split Tone",
    list11: "Shadows",
    list12: "Hue Saturation",
    list13: "Blacks & Whites",
    list14: "Luminance Adjustments for induvidual Colors",
  },

  //   {
  //     id: 3,
  //     img: "https://www.photographersedit.com/wp-content/uploads/2024/12/sax-player.jpg",
  //     title: " Let Us Handle the Culling, So You Can Focus on the Magic",
  //     price: "Only $0.02 per photo.",
  //     para1:
  //       "As a wedding photographer, you know the story is in the details —but sorting through thousands of images to find the perfect  ones takes time. At Captureedits, we provide expert wedding photo culling services to help you save hours and stay focused on what you love: creating timeless memories for your clients.",
  //     heading: "What’s Included",
  //     heading1: "Precise Selection of the Best Moments ",
  //     para2:
  //       "We carefully go through your entire shoot to select only the sharpes t, most emotional, and visually  appealing photos.",
  //     heading2: "Remove Blinks, Duplicates & Missed Shots ",
  //     para3:
  //       "Our trained eyes eliminate unnecessary or fl awed images, giving you a clean, refined gallery to edit.",
  //     heading3: "Fast & Reliable Turnaround ",
  //     para4:
  //       "We know deadlines matter— especially for weddings. Get your culled images back fast without compromising quality.",
  //     heading4: "Custom Preferences? No Problem. ",
  //     para5:
  //       "Prefer more candid sho ts or certain poses? We follow your exact style and preferences to maintain your artistic vision",
  //     heading5: "Why Wedding Photographers Trust Us ",
  //     list1: " Save up to 6 -1 0 hours per wedding ",
  //     list2: "Maintain a consistent storytelling style ",
  //     list3: "Focus on editing the best images —not di gging through them ",
  //     list4: "Secure file handling and 100% confidentiality",
  //   },
];
